/*eslint-disable*/
import { cloneDeep, find } from 'lodash'

export default {
    props: ['currentPlayer', 'playersNumber', 'namesArray', 'sameSettingsAreActive'],
    data () {
        return {
            paramsArray: []
        }
    },
    watch: {
        params: {
            handler (val, oldVal) {
                if (!oldVal && !this.paramsArray.length) {
                    this.paramsArray.push(this.params);
                }
                if (this.sameSettingsAreActive) {
                    for (let x = 0; x < this.paramsArray.length; x++) {
                        if (x !== this.currentPlayer - 1) {
                            this.paramsArray[x] = cloneDeep(this.paramsArray[this.currentPlayer - 1]);
                        }
                    }
                }
                if (this.namesArray) {
                    this.namesArray.forEach((name, index) => {
                        if (this.paramsArray[index]) {
                            this.paramsArray[index].playerName = name;
                        }
                    });
                }
            },
            deep: true
        },
        currentPlayer (val) {
            this.params = this.paramsArray[val - 1];
            this.selectedDifficult = find(this.difficult, {name: this.params.difficult}) || find(this.difficult, {value: this.params.difficult});
            this.selectedMode = find(this.modes, {name: this.params.mode}) || find(this.modes, {value: this.params.mode});
            this.selectedPosition = find(this.positions, {name: this.params.position});
        },
        playersNumber (val) {
            if (val > this.paramsArray.length) {
                let length = val - this.paramsArray.length;
                for (let counter = 0; counter < length; counter++) {
                    this.paramsArray.push(cloneDeep(this.params));
                }
            } else {
                this.paramsArray.splice(val);
            }
            if (this.params.extraOptions) {
                if (val && val > 1) {
                    this.paramsArray.forEach(params => {
                        params.extraOptions.x2 = false;
                        params.extraOptions.motion = false;
                        params.extraOptions.music = false;
                        params.extraOptions.voiceOver = false;
                    });
                } else if (!this.params.fractions) {
                    this.params.extraOptions.voiceOver = true;
                }
            }
        },
        namesArray: {
            handler (arr) {
                arr.forEach((name, index) => {
                    if (this.paramsArray[index]) {
                        this.paramsArray[index].playerName = name;
                    }
                })
            },
            deep: true
        },
        sameSettingsAreActive (status) {
            if (status) {
                for (let x = 0; x < this.paramsArray.length; x++) {
                    if (x !== this.currentPlayer - 1) {
                        this.paramsArray[x] = cloneDeep(this.paramsArray[this.currentPlayer - 1]);
                    }
                }
                this.namesArray.forEach((name, index) => {
                    if (this.paramsArray[index]) {
                        this.paramsArray[index].playerName = name;
                    }
                });
                this.$emit('sameSettings', true);
            } else {
                this.$emit('sameSettings', false);
            }
        }
    }
}
